import type { ForManagerLocationDetail } from "@sidegigllc/api/client";
import { endOfMinute } from "date-fns";
import type { GigBoardArgs } from "domains/schedule/containers/GigBoard/queries";
import type { MarketplaceSearch } from "domains/schedule/utils/useMarketplaceSearch";
import type { WarmableQuery } from "routing/warmQueries";
import { queries as gigViewLayoutQueries } from "../GigViewLayout/queries";

type QueriesInput = {
  search: MarketplaceSearch;
  location: ForManagerLocationDetail | undefined;
  now: Date;
  isAdmin: boolean;
  includeTasks?: boolean;
};

export const historyGigArgs = (now: Date): GigBoardArgs => ({
  viewType: "HISTORY",
  end_time__lte: endOfMinute(now),
  ordering: "-start_time, -id",
});

export const queries = ({ search, location, now, isAdmin, includeTasks }: QueriesInput): Array<WarmableQuery> =>
  gigViewLayoutQueries({
    search,
    location,
    now,
    isAdmin,
    includeTasks,
    defaultView: "list",
    queryArgs: historyGigArgs,
  });
